<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template #activator="{ on, attrs }">
      <div>
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="white">mdi-account-circle</v-icon>
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="d-block mr-4">
            <v-list-item-title>{{ user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="logout">Logout</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { getLogoutUrl } from '../utils/auth';

export default {
  name: 'UserInfo',
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    logout () {
      ['sessionStorage'].map(storage => window[storage].clear());

      window.location.href = getLogoutUrl(window.location.origin, process.env.VUE_APP_SSO_CLIENT_ID, window.location.origin);
    }
  }
};
</script>
